import React, { useState, useEffect, useRef } from 'react';
import { useParams, Link, useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import './../../styles/chat/home.css';
import * as globals from './../../components/GlobalScripts.js';
import Rating from './../rating/Rating';

const Chat_home = () => {
    let path_api = localStorage.getItem('path_api');
    const navigate = useNavigate();
    const { id } = useParams();
    const location = useLocation();
    const [timeConversationEndRef, setTimeConversationEndRef] = useState(0);
    const [stripeChargeValue, setStripeChargeValue] = useState(0);
    const [paymentStatusProcess, setPaymentStatusProcess] = useState(0);
    const [sectionView, setSectionView] = useState(2);
    const [user, setUser] = useState([]);
    //PROFESIONAL ahora es la otra parte en el chat, antes era profesional ahora es solo la otra parte en el chat.
    const [profesional, setProfesional] = useState([]);
    const [newChat, setNewChat] = useState("");
    const [adjunto, setAdjunto] = useState(null);
    const [preview, setPreview] = useState(null);
    const [messages, setMessages] = useState([]);
    const [chatsHistory, setChatsHistory] = useState([]);
    const [step, setStep] = useState('propuesta');
    const [formDataPropuesta, setFormDataPropuesta] = useState({
        keys: '',
        sender: '',
        titulo: '',
        descripcion: '',
        precio: 0,
        cargada: false,
        estado: '',
        sender_accept: false,
        receiver_accept: false
    });
    const [formDataReview, setFormDataReview] = useState({});
    const [showAddAdicional, setShowAddAdicional] = useState(false);
    const [newAdicional, setNewAdicional] = useState({
        descripcion: '',
        precio: 100,
        estatus: 'pendiente'
    });

    useEffect(() => {
        if (id != "view")
            get_profil();

        if (id == "view")
            setSectionView(1)
        else
            setSectionView(2);

        setTimeConversationEndRef(0);

        setFormDataPropuesta({
            keys: '',
            sender: '',
            titulo: '',
            descripcion: '',
            precio: 0,
            cargada: false,
            estado: '',
            sender_accept: false,
            receiver_accept: false
        });
    }, [location]);

    const get_profil = () => {
        globals.openViewCharge();
        axios.post(`${path_api}/default/get_profile.php`, {
            rute: globals.getRuteBackend(),
            keylogin: id
        }).then(response => {
            if (response.data.mensaje === 'success') {
                setProfesional(response.data.profile);
            } else {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error",
                    msg: response.data.mensaje || "No se obtuvo el perfil",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
            }
        }).catch(error => {
            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: "Error al cargar el perfil",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4000
            });
        }).finally(() => {
            globals.closeViewCharge();
        });
    };

    useEffect(() => {
        const user_cache = localStorage.getItem('user');
        if (user_cache) {
            let userParsed = JSON.parse(user_cache);
            setUser(userParsed);
        }

        getMessages();
        getChatHistory();
        getProposal();

        const cachedData = localStorage.getItem('formDataSearch');
        const queryParams = new URLSearchParams(location.search);
        const act = queryParams.get("action");

        if (act == "presupuesto" && profesional?.rol) {
            startChat(JSON.parse(cachedData));
        }
    }, [location, location.search, profesional]);

    const getProposal = () => {
        axios.post(`${path_api}/chat/get_proposal.php`, {
            rute: globals.getRuteBackend(),
            session_id: globals.get_session_id(),
            keylogin: globals.get_keylogin(),
            key_primary: globals.get_keylogin(),
            key_secundary: id
        }).then(response => {
            if (response.data.mensaje === 'success') {
                const queryParams = new URLSearchParams(location.search);
                const act = queryParams.get("action");

                if (response.data.proposal) {
                    setFormDataPropuesta(response.data.proposal);
                } else if (!formDataPropuesta?.cargada && act != "presupuesto") {
                    setFormDataPropuesta({
                        keys: '',
                        sender: '',
                        titulo: '',
                        descripcion: '',
                        precio: 0,
                        cargada: false,
                        estado: '',
                        sender_accept: false,
                        receiver_accept: false
                    });
                }
            }
        }).catch(err => {
            setFormDataPropuesta({
                keys: '',
                sender: '',
                titulo: '',
                descripcion: '',
                precio: 0,
                cargada: false,
                estado: '',
                sender_accept: false,
                receiver_accept: false
            });
        });
    };

    const startChat = (temp) => {
        localStorage.removeItem('formDataSearch');
        if (temp?.action == "sendMessage" && (user?.rol == 1 && (profesional?.rol == 2 || profesional?.rol == 4) && temp)) {
            const msg = `${temp.descripcion_servicio}
            
            Asunto:
            ${temp.titulo}

            Categoria:
            ${temp.categoria}

            Opción seleccionada:
            ${temp.opt}

            Fecha y hora:
            ${temp.fecha} - ${temp.hora}

            Precotización:
            ${temp.precotizacion}
            
            Estado y ciudad:
            ${temp.estado} - ${temp.ciudad}`;

            autoMsg(msg);
        } else if ((user?.rol == 2 || user?.rol == 4) && profesional?.rol == 1) {
            setFormDataPropuesta({
                keys: globals.get_keylogin() + ',' + id,
                sender: id,
                titulo: '',
                descripcion: '',
                precio: 100,
                cargada: true,
                estado: "por_publicar",
                sender_accept: true,
                receiver_accept: false
            });
        } else if (user?.rol == 1 && (profesional?.rol == 2 || profesional?.rol == 4) && temp)
            setNewChat("Hola, necesito un servicio: " + temp?.descripcion_servicio);
    };

    const handleSubmit_Propuesta = async (e) => {
        e.preventDefault();
        globals.openViewCharge();
        axios.post(`${path_api}/chat/proposal.php`, {
            rute: globals.getRuteBackend(),
            session_id: globals.get_session_id(),
            keylogin: globals.get_keylogin(),
            proposal: formDataPropuesta,
        }).then(response => {
            if (response.data.mensaje === 'success') {
                globals.createAlert({
                    type: "success",
                    msg_title: "Éxito",
                    msg: "La propuesta se envió correctamente.",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
                setFormDataPropuesta(prev => ({ ...prev, estado: "publicada" }));
                let msg = `Mensaje automatico:
                    Propuesta creada.
                    Si no se actualiza tu propuesta recarga la página.

                    En espera de que el cliente acepte la propuesta.

                    Fecha de inicio:
                    ${formDataPropuesta.start ?? "No especificada"}

                    Fecha de fin:
                    ${formDataPropuesta.end ?? "No especificada"}

                    Titulo:
                    ${formDataPropuesta.titulo}

                    Descripcion:
                    ${formDataPropuesta.descripcion}

                    Precio:
                    $${formDataPropuesta.precio} MXN`;
                newMsgSystem(msg);
            } else {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error",
                    msg: response.data.mensaje || "No se pudo enviar la propuesta.",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
            }
        }).catch(error => {
            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: "Error al enviar la propuesta.",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4000
            });
        }).finally(() => {
            globals.closeViewCharge();
        });
    };

    const handleUpdate_Propuesta = async (e) => {
        e.preventDefault();
        globals.openViewCharge();
        axios.post(`${path_api}/chat/update_data_proposal.php`, {
            session_id: globals.get_session_id(),
            keylogin: globals.get_keylogin(),
            proposal: formDataPropuesta,
        }).then(response => {
            if (response.data.mensaje === 'success') {
                globals.createAlert({
                    type: "success",
                    msg_title: "Éxito",
                    msg: "La propuesta se actualizo correctamente.",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
                let msg = "";
                if(formDataPropuesta.profesional_assign?.nombre){
                    msg = `Mensaje automatico:
                    Profesional asignado.
                    Si no se actualiza tu propuesta recarga la página.

                    Nombre del profesional:
                    ${formDataPropuesta.profesional_assign?.nombre} ${formDataPropuesta.profesional_assign?.apellidos}`;
                }else{
                    msg = `Mensaje automatico:
                    Propuesta actualizada.
                    Si no se actualiza tu propuesta recarga la página.

                    Fecha de inicio:
                    ${formDataPropuesta.start ?? "No especificada"}

                    Fecha de fin:
                    ${formDataPropuesta.end ?? "No especificada"}`;
                }
                newMsgSystem(msg);
            } else {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error",
                    msg: response.data.mensaje || "No se pudo actualizar la propuesta.",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
            }
        }).catch(error => {
            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: "Error al conectar con el servidor",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4000
            });
        }).finally(() => {
            globals.closeViewCharge();
        });
    };

    const handleUpdateAdicionales_Propuesta = async (proposal, newProposal) => {
        globals.openViewCharge();
        axios.post(`${path_api}/chat/update_adicionales_proposal.php`, {
            session_id: globals.get_session_id(),
            keylogin: globals.get_keylogin(),
            proposal,
            newProposal
        }).then(response => {
            if (response.data.mensaje === 'success') {
                globals.createAlert({
                    type: "success",
                    msg_title: "Éxito",
                    msg: "Los adicionales se actualizaron correctamente.",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
                let msg = `Mensaje automatico:
                    Adicionales actualizados.
                    Si no se actualizan tus adicionales recarga la página.`;
                newMsgSystem(msg);
                setFormDataPropuesta(response.data.proposal);
            } else {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error",
                    msg: response.data.mensaje || "No se actualizaron los adicionales.",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
            }
        }).catch(error => {
            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: "Error al conectar con el servidor",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4000
            });
        }).finally(() => {
            globals.closeViewCharge();
        });
    };

    const handleAnticipo_Propuesta = async (e) => {
        e.preventDefault();
        globals.openViewCharge();
        axios.post(`${path_api}/chat/anticipo_proposal.php`, {
            session_id: globals.get_session_id(),
            keylogin: globals.get_keylogin(),
            proposal: formDataPropuesta,
        }).then(response => {
            if (response.data.mensaje === 'success') {
                globals.createAlert({
                    type: "success",
                    msg_title: "Éxito",
                    msg: "El anticipo se envio correctamente correctamente.",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
                let msg = `Mensaje automatico:
                    Anticipo enviado.
                    Si no se actualiza tu propuesta recarga la página.

                    Cantidad anticipada:
                    ${parseFloat(formDataPropuesta.anticipo) * 100}%
                    
                    En MXN:
                    ${response.data.amount}`;

                newMsgSystem(msg);
            } else {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error",
                    msg: response.data.mensaje || "No se pudo enviar el anticipo.",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
            }
        }).catch(error => {
            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: "Error al conectar con el servidor",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4000
            });
        }).finally(() => {
            globals.closeViewCharge();
        });
    };

    const newMsgSystem = async (msg, refresh) => {
        const formData = new FormData();
        formData.append('rute', globals.getRuteBackend());
        formData.append('session_id', globals.get_session_id());
        formData.append('keylogin', globals.get_keylogin());
        formData.append('keys', user?.keylogin + ',' + id);
        formData.append('msg', msg);
        formData.append('sender', 'System');

        globals.openViewCharge();
        axios.post(`${path_api}/chat/send_message.php`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        }).then(response => {
            if (response.data.mensaje === 'success') {
                getMessages();
                getChatHistory();
                if (refresh)
                    navigate(`/chat/${profesional.keylogin}/`)
            } else {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error",
                    msg: response.data.mensaje || "No se pudo enviar el mensaje",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
            }
        }).catch(error => {
            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: "Error al enviar el mensaje",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4000
            });
        }).finally(() => {
            globals.closeViewCharge();
        });
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormDataPropuesta({ ...formDataPropuesta, [name]: value });
    };

    const getMessages = () => {
        axios.post(`${path_api}/chat/get_messages.php`, {
            rute: globals.getRuteBackend(),
            session_id: globals.get_session_id(),
            keylogin: globals.get_keylogin(),
            key_primary: globals.get_keylogin(),
            key_secundary: id
        }).then(response => {
            if (response.data.mensaje === 'success') {
                setMessages(response.data.messages);
            }
        }).catch(err => {
            console.error(err);
        });
    };

    const getChatHistory = () => {
        axios.post(`${path_api}/chat/get_conversations.php`, {
            rute: globals.getRuteBackend(),
            session_id: globals.get_session_id(),
            keylogin: globals.get_keylogin()
        }).then(response => {
            if (response.data.mensaje === 'success') {
                setChatsHistory(response.data.conversations);
            }
        }).catch(err => {
            console.error(err);
        });
    };

    useEffect(() => {
        let intervalId = setInterval(() => {
            if (id != "view")
                getMessages();
            getChatHistory();
        }, 5000);
        return () => clearInterval(intervalId);
    }, [id, user]);

    const handleFileChange = (e) => {
        const file = e.target.files?.[0];
        if (file) {
            setAdjunto(file);
            setPreview(URL.createObjectURL(file));
        } else {
            setAdjunto(null);
            setPreview(null);
        }
    };

    const autoMsg = async (msgAuto) => {
        const maxSize = 6 * 1024 * 1024;
        const formData = new FormData();
        formData.append('rute', globals.getRuteBackend());
        formData.append('session_id', globals.get_session_id());
        formData.append('keylogin', globals.get_keylogin());
        formData.append('keys', user?.keylogin + ',' + id);
        formData.append('msg', msgAuto);
        formData.append('sender', user?.keylogin);

        if (adjunto) {
            if (adjunto.size > maxSize) {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error",
                    msg: "El adjunto excede el tamaño máximo de 6MB",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
                return;
            }
            formData.append('adjunto', adjunto);
        } else {
            if (!msgAuto) {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error",
                    msg: "No puedes enviar un mensaje vacio",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
                return;
            }
        }

        globals.openViewCharge();
        axios.post(`${path_api}/chat/send_message.php`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        }).then(response => {
            if (response.data.mensaje === 'success') {
                setTimeConversationEndRef(0);
                setNewChat("");
                getMessages();
                getChatHistory();
                setAdjunto(null);
                setPreview(null);
                const imgInput = document.getElementById('image');
                if (imgInput) {
                    imgInput.value = '';
                }
            } else {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error",
                    msg: response.data.mensaje || "No se pudo enviar el mensaje",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
            }
        }).catch(error => {
            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: "Error al enviar el mensaje",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4000
            });
        }).finally(() => {
            globals.closeViewCharge();
        });
    };

    const handleSubmit_Chat = async (e, msgAuto = '') => {
        e.preventDefault();
        const maxSize = 6 * 1024 * 1024;
        const formData = new FormData();
        formData.append('rute', globals.getRuteBackend());
        formData.append('session_id', globals.get_session_id());
        formData.append('keylogin', globals.get_keylogin());
        formData.append('keys', user?.keylogin + ',' + id);
        formData.append('msg', newChat);
        formData.append('sender', user?.keylogin);

        if (adjunto) {
            if (adjunto.size > maxSize) {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error",
                    msg: "El adjunto excede el tamaño máximo de 6MB",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
                return;
            }
            formData.append('adjunto', adjunto);
        } else {
            if (!newChat) {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error",
                    msg: "No puedes enviar un mensaje vacio",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
                return;
            }
        }

        globals.openViewCharge();
        axios.post(`${path_api}/chat/send_message.php`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        }).then(response => {
            if (response.data.mensaje === 'success') {
                setTimeConversationEndRef(0);
                setNewChat("");
                getMessages();
                getChatHistory();
                setAdjunto(null);
                setPreview(null);
                const imgInput = document.getElementById('image');
                if (imgInput) {
                    imgInput.value = '';
                }
            } else {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error",
                    msg: response.data.mensaje || "No se pudo enviar el mensaje",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
            }
        }).catch(error => {
            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: "Error al enviar el mensaje",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4000
            });
        }).finally(() => {
            globals.closeViewCharge();
        });
    };

    const conversationEndRef = useRef(null);

    useEffect(() => {
        if (timeConversationEndRef == 0 && messages.length) {
            setTimeConversationEndRef(1);
            conversationEndRef.current?.scrollIntoView({ behavior: 'smooth' });
        }
    }, [messages]);

    const proposal_update = async (estado, sender_accept, receiver_accept, msg) => {
        globals.openViewCharge();
        axios.post(`${path_api}/chat/update_proposal.php`, {
            rute: globals.getRuteBackend(),
            session_id: globals.get_session_id(),
            keylogin: globals.get_keylogin(),
            id_proposal: formDataPropuesta.id,
            estado: estado,
            sender_accept: sender_accept,
            receiver_accept: receiver_accept
        }).then(response => {
            if (response.data.mensaje === 'success') {
                globals.createAlert({
                    type: "success",
                    msg_title: "Éxito",
                    msg: "La propuesta se actualizo correctamente.",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
                setFormDataPropuesta(response.data.proposal);
                if (!msg)
                    msg = `Mensaje automatico:
                        Si no se actualiza tu propuesta recarga la página.

                        Cambio de estado de la propuesta.

                        Estado:
                        ${estado}`;
                newMsgSystem(msg, 1);
            } else {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error",
                    msg: response.data.mensaje || "No se pudo actualizar la propuesta.",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
            }
        }).catch(error => {
            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: "Error al actualizar la propuesta.",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4000
            });
        }).finally(() => {
            globals.closeViewCharge();
        });
    };

    useEffect(() => {
        const script = document.createElement("script");
        script.src = "https://js.stripe.com/v3/";
        script.async = true;
        document.body.appendChild(script);

        script.onload = () => {
            initializeStripe();
        };

        return () => {
            document.body.removeChild(script);
        };
    }, []);

    const initializeStripe = async () => {
        await axios
            .post(`${path_api}/get_stripe_keys.php`, {
                rute: globals.getRuteBackend()
            })
            .then((response) => {
                if (response.data.mensaje === "success") {
                    if (!window.stripe)
                        window.stripe = window.Stripe(response.data.key_public);
                } else {
                    globals.createAlert({
                        type: "error",
                        msg_title: "Error",
                        msg: response.data.mensaje || "Sin comunicación con Stripe",
                        effect: "opacidad 2s, desplazamiento 2s",
                        time_life: 4000,
                    });
                }
            })
            .catch((error) => {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error 'log-stripe-1'",
                    msg: "Si persiste informa al soporte",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000,
                });
            });
    };

    useEffect(() => {
        if (formDataPropuesta?.estado == 'por_pagar' && formDataPropuesta?.sender == user.keylogin) {
            const queryParams = new URLSearchParams(location.search);
            const act = queryParams.get("payment_status");

            if (!act && step != 'propuesta') {
                return;
            }

            if (!act) {
                setStripeChargeValue(0);
                chargeStripe();
            } else {
                if (paymentStatusProcess)
                    return;

                setPaymentStatusProcess(1);

                if (act == 'succeeded' && formDataPropuesta.precio == formDataPropuesta.pagado)
                    proposal_update("pagado", formDataPropuesta.sender_accept, formDataPropuesta.receiver_accept);
                else if (act == 'succeeded')
                    proposal_update("por_pagar", formDataPropuesta.sender_accept, formDataPropuesta.receiver_accept, `Mensaje automatico:
                        Si no se actualiza tu propuesta recarga la página.

                        El pago parcial fue exitoso.

                        Estado del pago:
                        ${act}
                        
                        El pago seguira pendiente`);
                else {
                    proposal_update("por_pagar", formDataPropuesta.sender_accept, formDataPropuesta.receiver_accept, `Mensaje automatico:
                        Si no se actualiza tu propuesta recarga la página.

                        El pago no obtuvo una respuesta de exito.

                        Estado del pago:
                        ${act}
                        
                        El pago seguira pendiente`);
                }
            }
        }

        let intervalId_ = setInterval(() => {
            if ((formDataPropuesta?.estado == 'por_publicar' && formDataPropuesta.sender != user?.keylogin) ||
                (formDataPropuesta?.estado == 'publicada' && formDataPropuesta.sender == user?.keylogin) ||
                (formDataPropuesta?.estado == 'por_pagar' && formDataPropuesta.sender == user?.keylogin) ||
                (formDataPropuesta?.estado == 'pagado' && formDataPropuesta.sender == user?.keylogin) ||
                formDataPropuesta?.estado == 'finalizada')
                return;

            if (id != "view" && step == 'propuesta')
                getProposal();
        }, 5000);
        return () => clearInterval(intervalId_);
    }, [formDataPropuesta]);

    const chargeStripe = async () => {
        globals.openViewCharge();
        await axios
            .post(`${path_api}/stripe/create_project.php`, {
                rute: globals.getRuteBackend(),
                session_id: globals.get_session_id(),
                keylogin: globals.get_keylogin(),
                proposal: formDataPropuesta
            })
            .then(async (response) => {
                if (response.data.mensaje === "success") {
                    const intervalId = setInterval(async () => {
                        const paymentElement = document.querySelector('#payment-element');
                        if (paymentElement) {
                            setStripeChargeValue(1);
                            window.clientSecret = response.data.response.client_secret;

                            window.elements = window.stripe.elements({ clientSecret: window.clientSecret });

                            await window.elements.create("payment", { layout: "tabs" }).mount("#payment-element");

                            globals.closeViewCharge();

                            clearInterval(intervalId);
                        }
                    }, 1000);
                } else {
                    globals.createAlert({
                        type: "error",
                        msg_title: "Error",
                        msg: response.data.mensaje || "Sin comunicación con Stripe",
                        effect: "opacidad 2s, desplazamiento 2s",
                        time_life: 4000,
                    });
                    globals.closeViewCharge();
                }
            })
            .catch((error) => {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error 'log-stripe-2'",
                    msg: "Si persiste informa al soporte",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000,
                });
                globals.closeViewCharge();
            });
    };

    const handleSubmit_Stripe = async (e) => {
        e.preventDefault();
        globals.openViewCharge();

        let redirect = `${globals.getRuteHost()}/chat/${profesional.keylogin}/`;
        let url = `https://donhonesto.com/backend/stripe/confirm_project/?redirect=${encodeURIComponent(redirect)}&proposal_id=${formDataPropuesta.id}`;
        await window.stripe.confirmPayment({
            elements: window.elements,
            confirmParams: {
                return_url: url,
            },
        }).then(function (result) {
            if (result.error) {
                globals.createAlert({ type: "error", msg_title: "Error", msg: result.error.message, effect: "opacidad 2s, desplazamiento 2s", time_life: 6000 });
            } else {
                globals.createAlert({ type: "error", msg_title: "Error", msg: "Error interno, intenta más tarde", effect: "opacidad 2s, desplazamiento 2s", time_life: 8000 });
            }
            globals.closeViewCharge();
        });
    };

    const handleSubmit_Review = async (e) => {
        e.preventDefault();
        let review = {
            id_proposal: formDataPropuesta.id,
            sender: formDataPropuesta.sender == user.keylogin ? user.keylogin : id,
            recieved: formDataPropuesta.sender != user.keylogin ? user.keylogin : id,
            type: formDataPropuesta.sender == user.keylogin ? 'cliente' : 'profesional',
            rating: formDataReview.rating,
            description: formDataReview.descripcion,
            sender_review: formDataPropuesta.sender == user.keylogin ? 1 : 0,
            receiver_review: formDataPropuesta.sender != user.keylogin ? 1 : 0,
        }
        globals.openViewCharge();
        axios.post(`${path_api}/chat/new-review.php`, {
            rute: globals.getRuteBackend(),
            session_id: globals.get_session_id(),
            keylogin: globals.get_keylogin(),
            review: review,
        }).then(response => {
            if (response.data.mensaje === 'success') {
                globals.createAlert({
                    type: "success",
                    msg_title: "Éxito",
                    msg: "La calificación se proceso con exito.",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
                setFormDataPropuesta(response.data.proposal);
            } else {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error",
                    msg: response.data.mensaje || "No se crear la calificación.",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
            }
        }).catch(error => {
            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: "Error al crear la calificación.",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4000
            });
        }).finally(() => {
            globals.closeViewCharge();
        });
    };

    const handleChange_review = (e) => {
        const { name, value } = e.target;
        setFormDataReview({ ...formDataReview, [name]: value });
    };

    useEffect(() => {

        document.querySelector('.container-chat .left-side')?.classList.add('mobile-hidden');
        document.querySelector('.container-chat .middle-side')?.classList.add('mobile-hidden');
        document.querySelector('.container-chat .right-side')?.classList.add('mobile-hidden');

        if (sectionView == 1)
            document.querySelector('.container-chat .left-side')?.classList.remove('mobile-hidden');
        if (sectionView == 2)
            document.querySelector('.container-chat .middle-side')?.classList.remove('mobile-hidden');
        if (sectionView == 3)
            document.querySelector('.container-chat .right-side')?.classList.remove('mobile-hidden');
    }, [sectionView]);

    const handleStepChange = (newStep) => {
        setStep(newStep);
        if (newStep == 'propuesta') {
            getProposal();
        }
        if (newStep == 'propuesta' && formDataPropuesta?.estado == 'por_pagar' && formDataPropuesta?.sender == user.keylogin) {
            const queryParams = new URLSearchParams(location.search);
            const act = queryParams.get("payment_status");

            if (!act) {
                setStripeChargeValue(0);
                chargeStripe();
            }
        }
    };

    const handleToggleAdicionalStatus = (index, status) => {
        const proposal = { ...formDataPropuesta };
        const actuales = formDataPropuesta.data_propuesta?.adicionales || [];
        const updated = [...actuales];
        updated[index] = { ...updated[index], estatus: status };

        const newProposal = {
            ...formDataPropuesta,
            data_propuesta: {
                ...formDataPropuesta.data_propuesta,
                adicionales: updated
            }
        };
        setFormDataPropuesta(newProposal);
        handleUpdateAdicionales_Propuesta(proposal, newProposal);
    };

    const handleSaveNewAdicional = (e) => {
        e.preventDefault();
        const proposal = { ...formDataPropuesta };
        const actuales = formDataPropuesta.data_propuesta?.adicionales || [];
        const newAddition = { ...newAdicional };
        const updated = [...actuales, newAddition];

        const newProposal = {
            ...formDataPropuesta,
            data_propuesta: {
                ...formDataPropuesta.data_propuesta,
                adicionales: updated
            }
        };
        setFormDataPropuesta(newProposal);
        handleUpdateAdicionales_Propuesta(proposal, newProposal);

        setNewAdicional({ descripcion: "", precio: 100, estatus: "pendiente" });
        setShowAddAdicional(false);
    };

    const handleChangeNewAdicional = e => {
        const { name, value } = e.target;
        setNewAdicional(prev => ({
            ...prev,
            [name]: name === 'precio' ? parseFloat(value) : value
        }));
    };

    const searchOnUser = (searchT) => {
        globals.openViewCharge();
        axios.post(`${path_api}/chat/search_profesional.php`, {
            session_id: globals.get_session_id(),
            keylogin: globals.get_keylogin(),
            searchT: searchT
        }).then(response => {
                if (response.data.mensaje === 'success') {
                    if (response.data.user) {
                        setFormDataPropuesta({ ...formDataPropuesta, profesional_assign: {
                            keylogin: response.data.user?.keylogin,
                            nombre: response.data.user?.account?.nombre,
                            apellidos: response.data.user?.account?.apellidos,
                            email: response.data.user?.email,
                        }});
                    } else {
                        globals.createAlert({
                            type: "advertencia",
                            msg_title: "Sin resultado",
                            msg: "No se obtuvieron resultados",
                            effect: "opacidad 2s, desplazamiento 2s",
                            time_life: 4000
                        });
                    }
                } else {
                    globals.createAlert({
                        type: "error",
                        msg_title: "Error",
                        msg: response.data.mensaje || "No se obtuvieron resultados",
                        effect: "opacidad 2s, desplazamiento 2s",
                        time_life: 4000
                    });
                }
            })
            .catch(error => {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error",
                    msg: "Error al conectar con el servidor",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
            })
            .finally(() => {
                globals.closeViewCharge();
            });
    };

    return (
        <>
            <div className='container-chat page-home'>
                <div className='left-side mobile-hidden'>
                    <h5>Aquí cargarán tus conversaciones</h5>
                    <div className="chats-history">
                        {chatsHistory && chatsHistory.length > 0 ? (
                            chatsHistory.map((chat, i) => (
                                <Link key={i} className={`profile-name ${chat.last_sender === user?.keylogin ? 'sent' : 'received'}`} to={`/chat/${chat.other_key}/`}>
                                    <img src={path_api + chat?.img_profile}></img>
                                    <div className='flex-column gap-5'>
                                        <h5>{chat?.nombre}</h5>
                                        <p>Mensaje: {chat?.msg}</p>
                                    </div>
                                </Link>
                            ))
                        ) : (
                            <p>No hay conversaciones.</p>
                        )}
                    </div>
                </div>
                {id != "view" && (
                    <div className="middle-side">
                        <button className='view-chats-history' onClick={() => setSectionView(1)}>
                            Conversaciones
                        </button>
                        <div className="conversation">
                            {messages.map((msg, i) => (
                                <div key={i} className={`chat-message ${msg.sender === user?.keylogin ? 'sent' : msg.sender === id ? 'received' : 'system'}`}>
                                    <span>
                                        {String(msg?.rute_adjunto) != '' && (
                                            <Link to={path_api + msg?.rute_adjunto} className='img-on-msg' target='_blank'>
                                                <img src={path_api + msg?.rute_adjunto}></img>
                                            </Link>
                                        )}
                                        <p>{msg.msg}</p>
                                        {msg.sender == user?.keylogin && msg.seen == 1 && (
                                            <p className='status-msg'>
                                                <svg viewBox="0 0 77 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M43.0625 2.0625C43.9429 1.22431 45.1145 0.760918 46.3301 0.770116C47.5457 0.779313 48.7102 1.26038 49.5778 2.1118C50.4454 2.96322 50.9484 4.1184 50.9805 5.33359C51.0126 6.54878 50.5714 7.72892 49.75 8.625L24.8125 39.8125C24.3837 40.2744 23.8662 40.645 23.2908 40.9023C22.7155 41.1596 22.0942 41.2982 21.4641 41.3099C20.8339 41.3215 20.2079 41.206 19.6235 40.9702C19.039 40.7344 18.5081 40.3832 18.0625 39.9375L1.525 23.4C1.06446 22.9709 0.695067 22.4534 0.438868 21.8784C0.182668 21.3034 0.0449069 20.6827 0.033802 20.0533C0.0226971 19.4239 0.138476 18.7987 0.374232 18.215C0.609989 17.6313 0.960892 17.1011 1.40601 16.656C1.85113 16.2109 2.38134 15.86 2.96501 15.6242C3.54869 15.3885 4.17387 15.2727 4.80326 15.2838C5.43266 15.2949 6.05337 15.4327 6.62836 15.6889C7.20336 15.9451 7.72086 16.3145 8.15 16.775L21.2375 29.8563L42.9375 2.2L43.0625 2.0625ZM37.3125 34.1875L43.0625 39.9375C43.508 40.3822 44.0385 40.7326 44.6224 40.9678C45.2063 41.2031 45.8315 41.3183 46.4609 41.3066C47.0903 41.2949 47.7108 41.1566 48.2856 40.8999C48.8604 40.6432 49.3775 40.2734 49.8062 39.8125L74.7563 8.625C75.2044 8.18251 75.5589 7.65423 75.7984 7.07172C76.0379 6.48921 76.1575 5.86441 76.1502 5.23463C76.1428 4.60485 76.0086 3.98301 75.7556 3.40624C75.5026 2.82947 75.136 2.3096 74.6776 1.87768C74.2192 1.44576 73.6785 1.11065 73.0877 0.89235C72.4969 0.674052 71.8682 0.577048 71.2391 0.607133C70.61 0.637217 69.9934 0.793774 69.4261 1.06745C68.8589 1.34113 68.3526 1.72631 67.9375 2.2L46.2312 29.8563L43.2 26.8187L37.3125 34.1875Z" fill="black" />
                                                </svg>
                                            </p>
                                        )}
                                        {msg.sender == user?.keylogin && msg.seen == 0 && (
                                            <p className='status-msg'>
                                                <svg viewBox="0 0 52 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M43.5625 2.0625C44.4429 1.22431 45.6145 0.760918 46.8301 0.770116C48.0457 0.779313 49.2102 1.26038 50.0778 2.1118C50.9454 2.96322 51.4484 4.1184 51.4805 5.33359C51.5126 6.54877 51.0714 7.72892 50.25 8.625L25.3125 39.8125C24.8837 40.2744 24.3662 40.645 23.7908 40.9023C23.2155 41.1596 22.5942 41.2982 21.9641 41.3099C21.3339 41.3215 20.7079 41.206 20.1235 40.9702C19.539 40.7344 19.0081 40.3832 18.5625 39.9375L2.025 23.4C1.56446 22.9709 1.19507 22.4534 0.938868 21.8784C0.682668 21.3034 0.544906 20.6827 0.533801 20.0533C0.522696 19.4239 0.638477 18.7987 0.874233 18.215C1.10999 17.6313 1.46089 17.1011 1.90601 16.656C2.35113 16.2109 2.88134 15.86 3.46501 15.6242C4.04869 15.3885 4.67387 15.2727 5.30327 15.2838C5.93266 15.2949 6.55337 15.4327 7.12836 15.6889C7.70336 15.9451 8.22086 16.3145 8.65 16.775L21.7375 29.8562L43.4438 2.2L43.5625 2.0625Z" fill="black" />
                                                </svg>
                                            </p>
                                        )}
                                        <p className='date-msg'>
                                            {(() => {
                                                const date = new Date(msg.createAt);
                                                const now = new Date();
                                                const diffMs = now - date;
                                                const diffMinutes = Math.floor(diffMs / (1000 * 60));
                                                const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
                                                const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

                                                if (diffDays > 15) {
                                                    const day = String(date.getDate()).padStart(2, '0');
                                                    const month = String(date.getMonth() + 1).padStart(2, '0');
                                                    const hours = String(date.getHours()).padStart(2, '0');
                                                    const minutes = String(date.getMinutes()).padStart(2, '0');
                                                    return `${day} del ${month} a las ${hours}:${minutes}`;
                                                } else if (diffDays >= 1) {
                                                    return `hace ${diffDays} ${diffDays === 1 ? 'día' : 'días'}`;
                                                } else if (diffHours >= 1) {
                                                    return `hace ${diffHours} ${diffHours === 1 ? 'hora' : 'horas'}`;
                                                } else if (diffMinutes >= 1) {
                                                    return `hace ${diffMinutes} ${diffMinutes === 1 ? 'minuto' : 'minutos'}`;
                                                } else {
                                                    return "justo ahora";
                                                }
                                            })()}
                                        </p>
                                    </span>
                                </div>
                            ))}
                            <div ref={conversationEndRef} />
                            <button className='view-proposal' onClick={() => setSectionView(3)}>
                                Ver propuesta
                            </button>
                        </div>
                        <form onSubmit={handleSubmit_Chat}>
                            <input
                                type="file"
                                id="image"
                                name="image"
                                onChange={handleFileChange}
                                className="input-primary"
                                accept="image/*"
                                style={{ display: 'none' }}
                            />
                            {!preview && (
                                <button type='button' onClick={() => document.getElementById('image')?.click()}>
                                    <svg width="74" height="83" viewBox="0 0 74 83" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M46.6291 5.43495C49.5594 2.5047 53.5337 0.858497 57.6777 0.858497C61.8217 0.858497 65.796 2.5047 68.7262 5.43495C71.6565 8.36521 73.3027 12.3395 73.3027 16.4835C73.3027 20.6275 71.6565 24.6018 68.7262 27.532L28.9515 67.3068C27.1933 69.0649 24.8087 70.0527 22.3223 70.0527C19.8359 70.0527 17.4514 69.0649 15.6932 67.3068C13.935 65.5486 12.9473 63.1641 12.9473 60.6777C12.9473 58.1913 13.935 55.8067 15.6932 54.0485L46.6291 23.1126C47.2152 22.5266 48.01 22.1973 48.8388 22.1973C49.6676 22.1973 50.4625 22.5266 51.0485 23.1126C51.6346 23.6987 51.9638 24.4935 51.9638 25.3223C51.9638 26.1511 51.6346 26.946 51.0485 27.532L20.1126 58.468C19.5266 59.054 19.1973 59.8489 19.1973 60.6777C19.1973 61.5065 19.5266 62.3013 20.1126 62.8874C20.6987 63.4734 21.4935 63.8027 22.3223 63.8027C23.1511 63.8027 23.946 63.4734 24.532 62.8874L64.3068 23.1126C65.1773 22.2421 65.8679 21.2086 66.339 20.0712C66.8102 18.9337 67.0527 17.7146 67.0527 16.4835C67.0527 15.2524 66.8102 14.0333 66.339 12.8958C65.8679 11.7584 65.1773 10.7249 64.3068 9.85437C63.4362 8.98382 62.4028 8.29326 61.2653 7.82213C60.1279 7.35099 58.9088 7.1085 57.6777 7.1085C56.4465 7.1085 55.2274 7.35099 54.09 7.82213C52.9526 8.29326 51.9191 8.98382 51.0485 9.85437L11.2738 49.6291C8.34353 52.5594 6.69733 56.5337 6.69733 60.6777C6.69733 64.8217 8.34353 68.796 11.2738 71.7262C14.204 74.6565 18.1783 76.3027 22.3223 76.3027C26.4663 76.3027 30.4406 74.6565 33.3709 71.7262L64.3068 40.7903C64.8928 40.2042 65.6877 39.875 66.5165 39.875C67.3453 39.875 68.1402 40.2042 68.7262 40.7903C69.3123 41.3763 69.6415 42.1712 69.6415 43C69.6415 43.8288 69.3123 44.6237 68.7262 45.2097L37.7903 76.1456C33.6879 80.248 28.1239 82.5527 22.3223 82.5527C16.5207 82.5527 10.9567 80.248 6.85437 76.1456C2.75201 72.0433 0.447329 66.4793 0.447329 60.6777C0.447329 54.8761 2.75201 49.3121 6.85437 45.2097L46.6291 5.43495Z" fill="black" />
                                    </svg>
                                </button>
                            )}
                            {preview && (
                                <div className='container-img-adjunte'>
                                    <img src={preview} alt="Preview adjunto" />
                                    <button type="button" onClick={() => {
                                        setAdjunto(null);
                                        setPreview(null);
                                        const imgInput = document.getElementById('image');
                                        if (imgInput) {
                                            imgInput.value = '';
                                        }
                                    }}>x</button>
                                </div>
                            )}
                            <div className="form-group">
                                <textarea
                                    type="text"
                                    id="msg"
                                    name="msg"
                                    value={newChat}
                                    onChange={(e) => setNewChat(e.target.value)}
                                    className="input-primary"
                                    placeholder="¿Necesitas decir algo?..."
                                    rows="3"
                                />
                            </div>
                            <button type="submit">
                                <svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g>
                                        <path d="M99.775 4.2875C100.002 3.7196 100.058 3.09747 99.935 2.49825C99.8121 1.89902 99.516 1.34905 99.0835 0.916504C98.651 0.483964 98.101 0.18788 97.5018 0.064958C96.9025 -0.0579636 96.2804 -0.00231669 95.7125 0.225L4.79375 36.5937H4.7875L1.9625 37.7187C1.42744 37.9322 0.961784 38.2894 0.616973 38.7508C0.272161 39.2123 0.0616124 39.7601 0.00858403 40.3337C-0.0444443 40.9073 0.0621115 41.4844 0.316481 42.0013C0.570851 42.5181 0.963135 42.9546 1.45 43.2625L4.0125 44.8875L4.01875 44.9L35.2375 64.7625L55.1 95.9813L55.1125 95.9938L56.7375 98.5563C57.0464 99.0412 57.4831 99.4316 57.9996 99.6844C58.5161 99.9371 59.0923 100.042 59.6648 99.9889C60.2373 99.9352 60.7839 99.7247 61.2444 99.3804C61.7049 99.0361 62.0616 98.5714 62.275 98.0375L99.775 4.2875ZM88.3187 16.1L41.4812 62.9375L40.1375 60.825C39.8913 60.4373 39.5627 60.1087 39.175 59.8625L37.0625 58.5188L83.9 11.6812L91.2625 8.7375L88.3187 16.1Z" fill="black" />
                                    </g>
                                </svg>

                            </button>
                        </form>
                    </div>
                )}
                {id != "view" && (
                    <div className="right-side mobile-hidden">
                        <div className='flex-column gap-20'>
                            <div className="profile-name">
                                <img src={path_api + (profesional?.img_profile != '/images/profile_default.png' ? profesional?.account?.img_profile : profesional?.img_profile)}></img>
                                <div className='flex-column gap-5'>
                                    <h5>{profesional?.account?.nombre + ' ' + profesional?.account?.apellidos}</h5>
                                    {user?.rol == 4 && (
                                        <>
                                            <p><b>Email: </b>{profesional?.account?.email}</p>
                                            <p><b>Tel: </b>{profesional?.account?.phone}</p>
                                            <p></p>
                                        </>
                                    )}
                                    {profesional?.rol == 1 && (
                                        <p>Calificación como cliente</p>
                                    )}
                                    {profesional?.rol == 1 && (
                                        <Rating rating={profesional?.reviews?.average_rating_sender} size={20} />
                                    )}
                                    {!profesional?.reviews?.reviews_sender && profesional?.rol == 1 && (
                                        <div className="flex-column">
                                            <p>Sin evaluaciones como cliente</p>
                                        </div>
                                    )}
                                    {profesional?.rol == 2 && (
                                        <p>Calificación como profesional</p>
                                    )}
                                    {profesional?.rol == 4 && (
                                        <p><b className='text-green'>Cuenta de administrador</b></p>
                                    )}
                                    {profesional?.rol == 2 && (
                                        <Rating rating={profesional?.reviews?.average_rating_recieved} size={20} />
                                    )}
                                    {profesional?.rol == 4 && (
                                        <Rating rating={5} size={20} />
                                    )}
                                    {!profesional?.reviews?.reviews_recieved && profesional.rol == 2 && (
                                        <div className="flex-column">
                                            <p>Sin evaluaciones como profesional</p>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <button className='view-chat' onClick={() => setSectionView(2)}>
                                Volver al chat
                            </button>
                            <div className="nav-menu-chat">
                                <button type="button" onClick={() => handleStepChange('propuesta')} className={step === 'propuesta' ? 'active-nav' : ''}>Proyecto</button>
                                {formDataPropuesta.estado != "" && formDataPropuesta.estado != "por_publicar" && (user?.rol == 1 || user?.rol == 4) && (
                                    <>
                                        <button type="button" onClick={() => handleStepChange('ajustes')} className={step === 'ajustes' ? 'active-nav' : ''}>Ajustes</button>
                                    </>
                                )}

                                {formDataPropuesta.estado != "" && formDataPropuesta.estado != "por_publicar" &&
                                    formDataPropuesta.estado != "publicada" && (formDataPropuesta.estado != "por_pagar" ||
                                        (formDataPropuesta.estado == "por_pagar" && formDataPropuesta.pagado > 0)) && formDataPropuesta.sender == user?.keylogin && (
                                        <>
                                            <button type="button" onClick={() => handleStepChange('anticipos')} className={step === 'anticipos' ? 'active-nav' : ''}>Anticipos</button>
                                        </>
                                    )}

                                {formDataPropuesta.estado != "" && formDataPropuesta.estado != "por_publicar" &&
                                    formDataPropuesta.estado != "publicada" && (formDataPropuesta.estado != "por_pagar" ||
                                        (formDataPropuesta.estado == "por_pagar" && formDataPropuesta.adicionales == 1)
                                    ) && (
                                        <>
                                            <button type="button" onClick={() => handleStepChange('adicionales')} className={step === 'adicionales' ? 'active-nav' : ''}>
                                                Adicionales({formDataPropuesta.data_propuesta?.adicionales?.length ?? 0})
                                            </button>
                                        </>
                                    )}
                            </div>
                        </div>
                        {step == "propuesta" && (
                            <>
                                {formDataPropuesta?.cargada && formDataPropuesta.estado == 'por_publicar' && (user?.rol == 2 || user?.rol == 4) && profesional?.rol == 1 && (
                                    <form onSubmit={handleSubmit_Propuesta}>
                                        <div className="form-grop-row">
                                            <div className="form-group">
                                                <label>Fecha de inicio</label>
                                                <input
                                                    type="date"
                                                    name="start"
                                                    className="input-primary"
                                                    value={formDataPropuesta.start}
                                                    onChange={handleChange}
                                                />
                                            </div>

                                            <div className="form-group">
                                                <label>Fecha de fin</label>
                                                <input
                                                    type="date"
                                                    name="end"
                                                    className="input-primary"
                                                    value={formDataPropuesta.end}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                        </div>

                                        <div className="form-group">
                                            <label className='required'>Titulo</label>
                                            <input
                                                type="text"
                                                id="titulo"
                                                name="titulo"
                                                value={formDataPropuesta.titulo}
                                                onChange={handleChange}
                                                className="input-primary"
                                                placeholder="Ej. Creación de app"
                                                required
                                            />
                                        </div>

                                        <div className="form-group">
                                            <label className='required'>Descripción de servicio</label>
                                            <textarea
                                                type="text"
                                                id="descripcion"
                                                name="descripcion"
                                                value={formDataPropuesta.descripcion}
                                                onChange={handleChange}
                                                className="input-primary"
                                                placeholder="Ej. Realizare una app para tu restaurante..."
                                                rows="3"
                                                required
                                            />
                                        </div>

                                        <div className="form-group">
                                            <label className='required'>El cliente pagará por el servicio (MXN)</label>
                                            <input
                                                type="number"
                                                id="precio"
                                                name="precio"
                                                value={formDataPropuesta.precio}
                                                onChange={handleChange}
                                                className="input-primary"
                                                placeholder="Minimo 100"
                                                required
                                                style={{ maxWidth: "150px" }}
                                                min="100"
                                                onKeyDown={(e) => {
                                                    const allowedKeys = ["Backspace", "Tab", "ArrowLeft", "ArrowRight", "Delete", "Enter"];
                                                    if (allowedKeys.includes(e.key)) return;
                                                    if (!/^\d$/.test(e.key)) {
                                                        e.preventDefault();
                                                    }
                                                }}
                                            />
                                            <p>Recibirás: {(formDataPropuesta.precio - (formDataPropuesta.precio * 0.05 + 3)).toFixed(2)} MXN</p>
                                        </div>
                                        <button className='button-primary' type="submit">Crear propuesta</button>
                                    </form>
                                )}
                                {formDataPropuesta?.cargada && formDataPropuesta.estado == 'publicada' && formDataPropuesta.sender == user?.keylogin && (
                                    <div className="wait-response">
                                        <p className='text-green'>El profesional recibirá el pago hasta finalizar el proyecto o cuando liberes una parte.</p>
                                        <p>El profesional esperará hasta que aceptes la propuesta</p>
                                        <p><b>Fecha de inicio: </b>{formDataPropuesta.start}</p>
                                        <p><b>Fecha de termino: </b>{formDataPropuesta.end}</p>
                                        <p><b>Titulo: </b>{formDataPropuesta.titulo}</p>
                                        <p><b>Descripcion: </b>{formDataPropuesta.descripcion}</p>
                                        <p><b>Pagarás: </b>{formDataPropuesta.precio} MXN</p>

                                        <button className='button-primary red margin-top-15' onClick={() => proposal_update("rechazada", 0, 0)}>
                                            Rechazar
                                        </button>
                                        <button className='button-primary margin-top-15' onClick={() => proposal_update("por_pagar", 1, 1)}>
                                            Aceptar
                                        </button>
                                    </div>
                                )}
                                {formDataPropuesta?.cargada && formDataPropuesta.estado == 'publicada' && formDataPropuesta.sender != user?.keylogin && (
                                    <div className="wait-response">
                                        <p>En espera de que el cliente acepte la propuesta</p>
                                        <p><b>Fecha de inicio: </b>{formDataPropuesta.start}</p>
                                        <p><b>Fecha de termino: </b>{formDataPropuesta.end}</p>
                                        <p><b>Titulo: </b>{formDataPropuesta.titulo}</p>
                                        <p><b>Descripcion: </b>{formDataPropuesta.descripcion}</p>
                                        <p><b>Recibirás: </b>{(formDataPropuesta.precio - (formDataPropuesta.precio * 0.05 + 3)).toFixed(2)} MXN</p>
                                    </div>
                                )}
                                {formDataPropuesta?.cargada && formDataPropuesta.estado == 'por_pagar' && formDataPropuesta.sender == user?.keylogin && (
                                    <form onSubmit={handleSubmit_Stripe} className="flex-column gap-20">
                                        <h4>Pago de proyecto</h4>
                                        {formDataPropuesta.precio > 5000 && formDataPropuesta.pagado == 0 && formDataPropuesta.adicionales == 0 && (
                                            <>
                                                <p className='text-green'>Pagarás el 50% del total como anticipo y el restante al finalizar.</p>
                                                <p className='text-green'>El profesional recibirá el pago hasta finalizar el proyecto o cuando liberes una parte de lo que has pagado.</p>
                                                <p><b>Total: </b>${formDataPropuesta.precio} MXN</p>
                                                <p><b>Pagarás: </b>${formDataPropuesta.precio / 2} MXN</p>
                                            </>
                                        )}
                                        {formDataPropuesta.precio > 5000 && formDataPropuesta.pagado > 0 && formDataPropuesta.adicionales == 0 && (
                                            <>
                                                <p className='text-green'>Paga el saldo pendiente para poder marcar como completado o finalizar el proyecto.</p>
                                                <p className='text-green'>El profesional recibirá el pago hasta finalizar el proyecto o cuando liberes una parte de lo que has pagado.</p>
                                                <p className='text-red'>Si requieres servicios adicionales, es necesario que completes este pago.</p>
                                                <p><b>Total: </b>${formDataPropuesta.precio} MXN</p>
                                                <p><b>Pagado: </b>${formDataPropuesta.pagado} MXN</p>
                                                <p><b>Restante: </b>${formDataPropuesta.precio - formDataPropuesta.pagado} MXN</p>
                                            </>
                                        )}
                                        {formDataPropuesta.precio < 5000 && formDataPropuesta.adicionales == 0 && (
                                            <>
                                                <p className='text-green'>El profesional recibirá el pago hasta finalizar el proyecto o cuando liberes una parte de lo que has pagado.</p>
                                                <p className='text-red'>Si requieres servicios adicionales, es necesario que completes este pago.</p>
                                                <p><b>Pagarás: </b>${formDataPropuesta.precio} MXN</p>
                                            </>
                                        )}

                                        {formDataPropuesta.adicionales == 1 && (
                                            <>
                                                <p className='text-green'>El profesional recibirá el pago hasta finalizar el proyecto o cuando liberes una parte de lo que has pagado.</p>
                                                <p className='text-red'>Paga los servicios adicionales.</p>
                                                <p><b>Pagarás: </b>${formDataPropuesta.precio - formDataPropuesta.pagado} MXN</p>
                                            </>
                                        )}
                                        <div id="stripe-container">
                                            <div id="payment-element"></div>
                                        </div>
                                        {!!stripeChargeValue && (
                                            <div className='flex-column gap-10'>
                                                <button type="submit" className="button-primary green">Finalizar pago</button>
                                                <p className='text-green'>Al pagar en la plataforma, la calidad del servicio esta garantizada.</p>
                                            </div>
                                        )}
                                        {!stripeChargeValue && (
                                            <p>Esperando a que cargue la pasarela de pago.</p>
                                        )}
                                    </form>
                                )}
                                {formDataPropuesta?.cargada && formDataPropuesta.estado == 'por_pagar' && formDataPropuesta.sender != user?.keylogin && (
                                    <div className="wait-response">
                                        {formDataPropuesta.precio > 5000 && formDataPropuesta.pagado == 0 && formDataPropuesta.adicionales == 0 && (
                                            <>
                                                <p>Esperando que el cliente pague el 50% para iniciar el proyecto.</p>
                                            </>
                                        )}
                                        {formDataPropuesta.precio > 5000 && formDataPropuesta.pagado > 0 && formDataPropuesta.adicionales == 0 && (
                                            <>
                                                <p>Esperando que el cliente pague el saldo restante del proyecto.</p>
                                                <p className='text-red'>Si se requieren servicios adicionales, es necesario que el cliente complete este pago.</p>
                                                <p className='text-green'><b>Ya puedes trabajar en el proyecto.</b></p>
                                            </>
                                        )}
                                        {formDataPropuesta.precio < 5000 && formDataPropuesta.adicionales == 0 && (
                                            <>
                                                <p>Esperando que el cliente pague el proyecto</p>
                                                <p className='text-red'>Si se requieren servicios adicionales, es necesario que el cliente complete este pago.</p>
                                            </>
                                        )}

                                        {formDataPropuesta.adicionales == 1 && (
                                            <>
                                                <p className='text-red'>Esperando que el cliente pague los adicionales aceptados</p>
                                            </>
                                        )}
                                        <p><b>Fecha de inicio: </b>{formDataPropuesta.start}</p>
                                        <p><b>Fecha de termino: </b>{formDataPropuesta.end}</p>
                                        <p><b>Pagado: </b>{formDataPropuesta.pagado.toFixed(2)} MXN</p>
                                        <p><b>Recibido: </b>{formDataPropuesta.liberado.toFixed(2)} MXN</p>
                                        <p><b>Recibirás en total: </b>{(formDataPropuesta.precio - (formDataPropuesta.precio * 0.05 + 3)).toFixed(2)} MXN</p>
                                        <p>El monto se acreditará como saldo en tu cuenta al finalizar el proyecto o cuando el cliente libere una parte.</p>
                                    </div>
                                )}
                                {formDataPropuesta?.cargada && formDataPropuesta.estado == 'pagado' && formDataPropuesta.sender == user?.keylogin && (
                                    <div className="wait-response">
                                        <p className='text-green'>El profesional recibirá el pago hasta finalizar el proyecto.</p>
                                        <p>Esperando a que se complete el proyecto</p>
                                        <p>Una vez el profesional termine su trabajo deberás marcarlo como completado.</p>

                                        <button className='button-primary margin-top-15' onClick={() => proposal_update("completado", 1, 1)}>
                                            Marcar como completado
                                        </button>
                                    </div>
                                )}
                                {formDataPropuesta?.cargada && formDataPropuesta.estado == 'pagado' && formDataPropuesta.sender != user?.keylogin && (
                                    <div className="wait-response">
                                        <p>Esperando que el cliente marque como completado el proyecto</p>
                                        <p className='text-green'><b>Puedes pedirle al cliente un anticipo por el chat</b></p>
                                        <p><b>Pagado: </b>{formDataPropuesta.pagado.toFixed(2)} MXN</p>
                                        <p><b>Recibido: </b>{formDataPropuesta.liberado.toFixed(2)} MXN</p>
                                        <p><b>Recibirás en total: </b>{(formDataPropuesta.precio - (formDataPropuesta.precio * 0.05 + 3)).toFixed(2)} MXN</p>
                                        <p>El monto se acreditará como saldo en tu cuenta.</p>
                                    </div>
                                )}
                                {formDataPropuesta?.cargada && formDataPropuesta.estado == 'completado' && formDataPropuesta.sender == user?.keylogin && !formDataPropuesta.sender_review && (
                                    <form onSubmit={handleSubmit_Review}>
                                        <h4>Esto aparecerá en el perfil del profesional</h4>
                                        <div className="form-group">
                                            <label htmlFor="rating">Calificación (0-5)</label>
                                            <input
                                                type="number"
                                                id="rating"
                                                name="rating"
                                                value={formDataReview.rating}
                                                onChange={handleChange_review}
                                                className="input-primary"
                                                placeholder="0-5"
                                                required
                                                style={{ maxWidth: "100px" }}
                                                min="0"
                                                max="5"
                                                onKeyDown={(e) => {
                                                    const allowedKeys = ["Backspace", "Tab", "ArrowLeft", "ArrowRight", "Delete", "Enter"];
                                                    if (allowedKeys.includes(e.key)) return;
                                                    if (!/^\d$/.test(e.key)) {
                                                        e.preventDefault();
                                                    }
                                                }}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="descripcion">Describre tu experiencia con el profesional</label>
                                            <textarea
                                                type="text"
                                                id="descripcion"
                                                name="descripcion"
                                                value={formDataReview.descripcion}
                                                onChange={handleChange_review}
                                                className="input-primary"
                                                placeholder="EJ: Muy puntual y amable."
                                                rows="3"
                                                required
                                            />
                                        </div>
                                        <button className='button-primary' type="submit">Enviar</button>
                                    </form>
                                )}
                                {formDataPropuesta?.cargada && formDataPropuesta.estado == 'completado' && formDataPropuesta.sender != user?.keylogin && !formDataPropuesta.receiver_review && (
                                    <form onSubmit={handleSubmit_Review}>
                                        <h4>Esto aparecerá en el perfil del cliente</h4>
                                        <div className="form-group">
                                            <label htmlFor="rating">Calificación (0-5)</label>
                                            <input
                                                type="number"
                                                id="rating"
                                                name="rating"
                                                value={formDataReview.rating}
                                                onChange={handleChange_review}
                                                className="input-primary"
                                                placeholder="0-5"
                                                required
                                                style={{ maxWidth: "100px" }}
                                                min="0"
                                                max="5"
                                                onKeyDown={(e) => {
                                                    const allowedKeys = ["Backspace", "Tab", "ArrowLeft", "ArrowRight", "Delete", "Enter"];
                                                    if (allowedKeys.includes(e.key)) return;
                                                    if (!/^\d$/.test(e.key)) {
                                                        e.preventDefault();
                                                    }
                                                }}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="descripcion">Describre tu experiencia con el cliente</label>
                                            <textarea
                                                type="text"
                                                id="descripcion"
                                                name="descripcion"
                                                value={formDataReview.descripcion}
                                                onChange={handleChange_review}
                                                className="input-primary"
                                                placeholder="EJ: Muy puntual y amable."
                                                rows="3"
                                                required
                                            />
                                        </div>
                                        <button className='button-primary' type="submit">Enviar</button>
                                    </form>
                                )}
                                {formDataPropuesta?.cargada && formDataPropuesta.estado == 'completado' && formDataPropuesta.sender == user?.keylogin && formDataPropuesta.sender_review && !formDataPropuesta.receiver_review && (
                                    <div className="wait-response">
                                        <p>Esperando a que el profesional te califique</p>
                                    </div>
                                )}
                                {formDataPropuesta?.cargada && formDataPropuesta.estado == 'completado' && formDataPropuesta.sender != user?.keylogin && formDataPropuesta.receiver_review && !formDataPropuesta.sender_review && (
                                    <div className="wait-response">
                                        <p>Esperando a que el cliente te califique</p>
                                    </div>
                                )}
                                {formDataPropuesta?.cargada && formDataPropuesta.estado == 'completado' && formDataPropuesta.sender_review && formDataPropuesta.receiver_review && formDataPropuesta.sender == user?.keylogin && (
                                    <div className="wait-response">
                                        <p>Finaliza el proyecto para que se libere.</p>

                                        <button className='button-primary margin-top-15' onClick={() => proposal_update("finalizada", 1, 1)}>
                                            Marcar como finalizado
                                        </button>
                                    </div>
                                )}
                                {formDataPropuesta?.cargada && formDataPropuesta.estado == 'completado' && formDataPropuesta.sender_review && formDataPropuesta.receiver_review && formDataPropuesta.sender != user?.keylogin && (
                                    <div className="wait-response">
                                        <p>Esperando que el cliente marque como finalizado el proyecto.</p>
                                    </div>
                                )}
                                {(!formDataPropuesta?.cargada || formDataPropuesta.estado == 'finalizada') && ((user?.rol == 2 || user?.rol == 4) && profesional.rol == 1) && (
                                    <div className='error'>
                                        <p className='center'>
                                            No se encontró ninguna propuesta activa.
                                        </p>
                                        <Link to={`/chat/${profesional.keylogin}/?action=presupuesto`}>Genera una nueva propuesta</Link>
                                        <p className='center margin-top-15'>
                                            Si habia una, recargue la página.<br /><br />
                                            Si el problema persiste, informe al soporte.
                                        </p>
                                    </div>
                                )}
                                {(!formDataPropuesta?.cargada || formDataPropuesta.estado == 'finalizada') && ((user?.rol == 2 || user?.rol == 4) && profesional.rol == 2) && (
                                    <div className='error'>
                                        <p className='center'>
                                            No puedes generar una propuesta con otro profesional, el necesita crear una cuenta como cliente.
                                        </p>
                                    </div>
                                )}
                                {(!formDataPropuesta?.cargada || formDataPropuesta.estado == 'finalizada') && (user?.rol == 1) && (
                                    <div className='error'>
                                        <p className='center'>
                                            Solo el profesional puede generar una propuesta.
                                        </p>
                                    </div>
                                )}
                            </>
                        )}

                        {step == "ajustes" && (
                            <form onSubmit={handleUpdate_Propuesta}>
                                {formDataPropuesta.sender == user.keylogin ? (
                                    <>
                                        <div className="form-grop-row">
                                            <div className="form-group">
                                                <label>Fecha de inicio</label>
                                                <input
                                                    type="date"
                                                    name="start"
                                                    className="input-primary"
                                                    value={formDataPropuesta.start}
                                                    onChange={handleChange}
                                                    readOnly={formDataPropuesta.sender == user?.keylogin}
                                                />
                                            </div>

                                            <div className="form-group">
                                                <label>Fecha de fin</label>
                                                <input
                                                    type="date"
                                                    name="end"
                                                    className="input-primary"
                                                    value={formDataPropuesta.end}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        <h4>Asigna un profesional</h4>
                                        <h5 className='text-green'>El profesional recibirá los anticipos y pagos correspondientes.</h5>
                                        <div className="form-group">
                                            <label>Busqueda de profesional</label>
                                            <div className='flex-row gap-10'>
                                            <input
                                                type="text"
                                                name="searchT"
                                                value={formDataPropuesta?.searchT}
                                                onChange={handleChange}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                    e.preventDefault();
                                                    }
                                                }}
                                                className="input-primary"
                                                placeholder="Por nombre o email"
                                            />
                                                <span className='button-primary' onClick={() => searchOnUser(formDataPropuesta?.searchT)}>
                                                    Buscar
                                                </span>
                                            </div>
                                        </div>

                                        {formDataPropuesta.profesional_assign?.keylogin && formDataPropuesta.profesional_assign?.keylogin != "" && (
                                            <>
                                            <h5>Información del profesional asignado</h5>
                                            <p><b>Nombre:</b> {formDataPropuesta.profesional_assign?.nombre} {formDataPropuesta.profesional_assign?.apellidos}</p>
                                            <p><b>Email:</b> {formDataPropuesta.profesional_assign?.email}</p>
                                            </>
                                        )}
                                    </>
                                )}
                                <button className='button-primary' type="submit">Actualizar</button>
                                <p className='text-red'><b>Actualiza para guardar los cambios.</b></p>
                            </form>
                        )}

                        {step == "anticipos" && (
                            <form onSubmit={handleAnticipo_Propuesta}>
                                <h4>Libera dinero para el profesional</h4>
                                <div className="form-group">
                                    <label className='required'>Cantidad</label>
                                    <select
                                        name="anticipo"
                                        className="input-primary"
                                        value={formDataPropuesta?.anticipo}
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value="">Sin seleccionar</option>
                                        <option value="1">100%</option>
                                        <option value="0.75">75%</option>
                                        <option value="0.5">50%</option>
                                        <option value="0.33">33%</option>
                                        <option value="0.25">25%</option>
                                    </select>
                                </div>
                                <button className='button-primary' type="submit">Liberar dinero</button>
                            </form>
                        )}

                        {step === "adicionales" && (
                            <>
                                {!showAddAdicional ? (
                                    <>
                                        <form>
                                            {formDataPropuesta.data_propuesta?.adicionales?.length > 0 ? (
                                                formDataPropuesta.data_propuesta.adicionales.map((row, idx) => (
                                                    <div key={idx} className="additional-item">
                                                        <p><b>Descripción:</b> {row.descripcion}</p>
                                                        <p><b>Precio:</b> ${row.precio.toFixed(2)}</p>
                                                        <p><b>Estatus:</b> {row.estatus}</p>
                                                        {row.estatus == 'pendiente' && formDataPropuesta.sender == user?.keylogin && (
                                                            <div className="acciones">
                                                                <svg viewBox="0 0 70 54" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={() => handleToggleAdicionalStatus(idx, "aceptado")}>
                                                                    <path d="M61.6 1.8125C62.0265 1.37729 62.5356 1.03155 63.0974 0.795516C63.6592 0.559486 64.2625 0.437912 64.8719 0.437912C65.4813 0.437912 66.0845 0.559486 66.6463 0.795516C67.2081 1.03155 67.7172 1.37729 68.1438 1.8125C69.9313 3.61875 69.9563 6.5375 68.2063 8.375L31.25 52.0625C30.8304 52.5233 30.3212 52.8936 29.7536 53.1508C29.186 53.408 28.5719 53.5467 27.9488 53.5584C27.3257 53.5701 26.7068 53.4545 26.1299 53.2188C25.5531 52.9831 25.0303 52.6322 24.5938 52.1875L2.10625 29.4C1.23898 28.5155 0.753176 27.3262 0.753176 26.0875C0.753176 24.8488 1.23898 23.6595 2.10625 22.775C2.53279 22.3398 3.04187 21.994 3.60368 21.758C4.16549 21.522 4.76875 21.4004 5.37813 21.4004C5.9875 21.4004 6.59076 21.522 7.15257 21.758C7.71439 21.994 8.22346 22.3398 8.65 22.775L27.725 42.1062L61.475 1.95L61.6 1.8125Z" fill="var(--color-green)" />
                                                                </svg>
                                                                <svg viewBox="0 0 76 76" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={() => handleToggleAdicionalStatus(idx, "rechazado")}>
                                                                    <path d="M1.4125 5.8375C1.12195 5.54695 0.891474 5.20202 0.73423 4.8224C0.576986 4.44277 0.496053 4.0359 0.496053 3.625C0.496053 3.2141 0.576986 2.80723 0.73423 2.4276C0.891474 2.04798 1.12195 1.70305 1.4125 1.4125C1.70305 1.12195 2.04798 0.891474 2.4276 0.73423C2.80723 0.576986 3.2141 0.496053 3.625 0.496053C4.0359 0.496053 4.44277 0.576986 4.8224 0.73423C5.20202 0.891474 5.54695 1.12195 5.8375 1.4125L38 33.5812L70.1625 1.4125C70.453 1.12195 70.798 0.891474 71.1776 0.73423C71.5572 0.576986 71.9641 0.496053 72.375 0.496053C72.7859 0.496053 73.1928 0.576986 73.5724 0.73423C73.952 0.891474 74.2969 1.12195 74.5875 1.4125C74.878 1.70305 75.1085 2.04798 75.2658 2.4276C75.423 2.80723 75.5039 3.2141 75.5039 3.625C75.5039 4.0359 75.423 4.44277 75.2658 4.8224C75.1085 5.20202 74.878 5.54695 74.5875 5.8375L42.4187 38L74.5875 70.1625C74.878 70.453 75.1085 70.798 75.2658 71.1776C75.423 71.5572 75.5039 71.9641 75.5039 72.375C75.5039 72.7859 75.423 73.1928 75.2658 73.5724C75.1085 73.952 74.878 74.2969 74.5875 74.5875C74.2969 74.878 73.952 75.1085 73.5724 75.2658C73.1928 75.423 72.7859 75.5039 72.375 75.5039C71.9641 75.5039 71.5572 75.423 71.1776 75.2658C70.798 75.1085 70.453 74.878 70.1625 74.5875L38 42.4187L5.8375 74.5875C5.54695 74.878 5.20202 75.1085 4.8224 75.2658C4.44277 75.423 4.0359 75.5039 3.625 75.5039C3.2141 75.5039 2.80723 75.423 2.4276 75.2658C2.04798 75.1085 1.70305 74.878 1.4125 74.5875C1.12195 74.2969 0.891474 73.952 0.73423 73.5724C0.576986 73.1928 0.496053 72.7859 0.496053 72.375C0.496053 71.9641 0.576986 71.5572 0.73423 71.1776C0.891474 70.798 1.12195 70.453 1.4125 70.1625L33.5812 38L1.4125 5.8375Z" fill="var(--color-red)" />
                                                                </svg>
                                                            </div>
                                                        )}
                                                    </div>
                                                ))
                                            ) : (
                                                <p>No hay servicios adicionales.</p>
                                            )}
                                            {formDataPropuesta.sender != user?.keylogin && (
                                                <button type='button' className="button-primary" onClick={() => setShowAddAdicional(true)}>Nuevo adicional</button>
                                            )}
                                        </form>
                                    </>
                                ) : (
                                    <form onSubmit={handleSaveNewAdicional}>
                                        <div className="form-group">
                                            <label>Descripción</label>
                                            <input
                                                name="descripcion"
                                                value={newAdicional.descripcion}
                                                onChange={handleChangeNewAdicional}
                                                className="input-primary"
                                                required
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Precio</label>
                                            <input
                                                name="precio"
                                                type="number"
                                                value={newAdicional.precio}
                                                onChange={handleChangeNewAdicional}
                                                className="input-primary"
                                                required
                                                min="100"
                                            />
                                        </div>
                                        <button className="button-primary" type="submit">Agregar</button>
                                        <Link
                                            onClick={(e) => {
                                                e.preventDefault();
                                                setShowAddAdicional(false);
                                            }}
                                        >
                                            Cancelar
                                        </Link>
                                    </form>
                                )}
                            </>
                        )}

                    </div>
                )}
            </div>
        </>
    );
};

export default Chat_home;